import React, { Component } from 'react';
import qs from 'qs';
import { useLocation, useHistory } from 'react-router-dom';
import { ProjectMapPanel, ProjectSidePanel} from "../../Components";
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, Configure } from 'react-instantsearch-dom';


const searchClient = algoliasearch('6KMP52GB5X', 'a4bb5f7de85b6dc3b2313ece00f93394');
const createURL = (state) => `?${qs.stringify(state)}`;
const DEBOUNCE_TIME = 700;
const PROJECT_INDEX = window.project_index

const mapWrapper = {
  display: 'flex',
  width: '100%',
  height: '100%',
  minHeight: '100%',
  position: 'relative'
}

const searchStateToUrl = (location, searchState) =>
  searchState ? `${location.pathname}${createURL(searchState)}` : '';

const urlToSearchState = (location) => qs.parse(location.search.slice(1));

export default class ProjectMap extends Component {

  constructor(props) {
    super(props);
    this.setStateId = React.createRef();
    this.state = {
      searchState: urlToSearchState(this.props.location),
      locationState: null,
      locationType: null,
    };
  }

  componentDidUpdate(prevProps) {
    const nextSearchState = urlToSearchState(this.props.location);
    if (JSON.stringify(this.state.searchState) !== JSON.stringify(nextSearchState)) {
      this.setState({searchState: nextSearchState})
    }
    if (document.getElementById('field-address').value === '' && this.state.locationState !== null) {
      this.setState({locationState: null});
    }
  }

  _onSearchStateChange = (nextSearchState) => {
    clearTimeout(this.setStateId.current);

    this.setStateId.current = setTimeout(() => {
      this.props.history.push(
        searchStateToUrl(this.props.location, nextSearchState),
        nextSearchState
      );
    }, DEBOUNCE_TIME);

    this.setState({searchState: nextSearchState})

  }

  _onLocationStateSearch = (locationState) => {
      console.log('locationState', locationState);
      if (locationState === null) {
          this.setState({locationState});
          this.setState({locationType: null});
          return true;
      }
      if (locationState.hasOwnProperty('name') ) {
          this.setState({locationState : locationState.name});
      }
      if (locationState.hasOwnProperty('type') ) {
          this.setState({locationType : locationState.type});
      }
      return true;
  }

  setLocationFacetType = (name, type) =>
    this.setState(({ filterPanelVisible }) => ({
      filterPanelVisible: !filterPanelVisible,
    }));


  render() {
      return (
        <div style={mapWrapper}>
        <InstantSearch
          searchClient={searchClient}
          createURL={searchState => `?q=${searchState.query}`}
          indexName={PROJECT_INDEX}
          searchState={this.state.searchState}
          onSearchStateChange={this._onSearchStateChange}
          >
            {this.state.locationState !== null &&
              <Configure filters={this.state.locationType + ':' + this.state.locationState} />
            }
            <div className="map__content" style={{'height': '100%'}}>
              <ProjectMapPanel stateSearchFilter={this._onLocationStateSearch} />
            </div>
            <div className="map__results" style={{'height': '100%'}}>
              <ProjectSidePanel />
            </div>
        </InstantSearch>
        </div>
      );
    }
}
